import styled from "styled-components";

export const Block = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 520,
  padding: 20,

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: 16,

  "& p": {
    margin: 0,
    lineHeight: 1.5,
  },
}));

export const Prices = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 6,
  padding: "12px 16px",
  borderRadius: 8,
  backgroundColor: "#f5f6f8",

  "& .row": {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    fontSize: 15,
  },

  "& .old": {
    color: "#8a8f98",
    textDecoration: "line-through",
  },

  "& .new": {
    fontWeight: 700,
    fontSize: 18,
  },
});

export const Note = styled("p")({
  color: "#c0392b",
  fontSize: 14,
});

export const Buttons = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  gap: 12,
  justifyContent: "center",
  flexWrap: "wrap",

  "& button": {
    flex: "1 1 180px",
    maxWidth: 240,
    padding: "10px 20px",
    border: "none",
    borderRadius: 5,
    fontSize: 16,
    cursor: "pointer",
    transition: "background-color 0.3s ease, opacity 0.3s ease",

    "&:disabled": {
      opacity: 0.6,
      cursor: "default",
    },
  },

  "& button.agree": {
    color: "#fff",
    backgroundColor: theme.palette.searchButtonBg,

    "&:hover:not(:disabled)": {
      backgroundColor: theme.palette.hoverButtonBg,
    },
  },

  "& button.disagree": {
    color: theme.palette.searchButtonBg,
    border: `1px solid ${theme.palette.searchButtonBg}`,
    backgroundColor: "transparent",

    "&:hover:not(:disabled)": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
}));
